<template>
  <component :is="iconComponent" v-if="name" :size="size" :class="classes" />
</template>

<script>
import * as icons from 'lucide-vue-next'
export default {
  name: 'IconProvider',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 24
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconComponent() {
      console.log('IconProvider: name', this.name);
      return icons[this.name]
    }
  }
}
</script>
